import React, { useEffect, useState } from "react";
import logo from "../Assets/Slide3/jyothilogo.png";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaTwitter,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const [events, setEvents] = useState([]);
  const [uniqueCategoryNames, setUniqueCategoryNames] = useState([]);
  const navigate = useNavigate(); // useNavigate hook for navigation
  useEffect(() => {
    fetch(SummaryApi.getevents.url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log("Fetched data:", data);
        // Access the data field and filter for both "Campus" and "Achievements"
        const filteredEvents = data.data.filter(
          (event) =>
            event.category_name === "Campus" ||
            event.category_name === "Achievements"
        );
        // console.log("Filtered Campus and Achievements Events:", filteredEvents);
        setEvents(filteredEvents); // Set the filtered events state
      })
      .catch((error) => {
        // console.error("Error fetching events:", error);
      });
  }, []);
  const handleEventClick = (event) => {
    // Scroll to the top of the page
    window.scrollTo(0, 0); // Scroll to the top before navigation
    // Pass all events along with the clicked event to the EventsScreen
    navigate("/events-screen", {
      state: {
        eventDetails: event,
        allEvents: events,
      },
    });
  };
  const uniqueCategories = [
    ...new Set(events.map((event) => event.category_name)),
  ];
  return (
    <div className="bg-gray-800 text-white p-10 ">
      <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row lg:justify-between lg:space-x-8">
        {/* First Column: Logo and Text */}
        <div className="lg:w-1/3 mb-8 lg:mb-0">
          <a
            href="/"
            className="flex flex-col items-center text-white font-poppins font-semibold"
          >
            <img
              src={logo}
              alt="Logo"
              className="mb-5"
              style={{
                maxHeight: "12vh",
                minHeight: "10vh",
                objectFit: "contain",
              }}
            />
            <p className="mt-[-2%] text-sm mb-2 text-center">
              "To Create A Collaborative Academic <br /> Environment To Foster
              Professional <br />
              Excellence And Ethical Values."
            </p>
            <div className="flex gap-2 justify-center">
              <a
                href="https://www.facebook.com/srijyothi.polytechnic"
                className="flex items-center space-x-2 hover:text-gray-400"
              >
                <FaFacebook className="text-blue-600 text-xl" />
              </a>
              <a
                href="https://www.instagram.com/srijyothipolytechnic451?igsh=bmh1dzdzeGIxY25i"
                className="flex items-center space-x-2 hover:text-gray-400"
              >
                <FaInstagram className="text-pink-600 text-xl" />
              </a>
              <a
                href="https://www.linkedin.com/company/sri-jyothi-polytechnic/"
                className="flex items-center space-x-2 hover:text-gray-400"
              >
                <FaLinkedin className="text-blue-700 text-xl" />
              </a>
              <a
                href="https://youtu.be/CDDqFLaSIl8?si=GiynOPHWtwH6MNJX"
                className="flex items-center space-x-2 hover:text-gray-400"
              >
                <FaYoutube className="text-red-600 text-xl" />
              </a>
              <a
                href="https://twitter.com"
                className="flex items-center space-x-2 hover:text-gray-400"
              >
                <FaTwitter className="text-blue-500 text-xl" />
              </a>
              <a
                href="https://wa.me/919390019382"
                className="flex items-center space-x-2 hover:text-gray-400"
              >
                <FaWhatsapp className="text-green-500 text-xl" />
              </a>
            </div>
          </a>
        </div>

        {/* Second Column: Office Address */}
        <div className="lg:w-1/3 flex flex-col items-center mb-5">
          <h3 className="text-xl font-semibold mb-2 text-white ">Our Source</h3>
          <div className="text-left mr-4">
            <h6 className="mb-2 text-white text-sm">
              <a href="/courses">Courses</a>
            </h6>
            <h6 className="mb-2 text-white text-sm">
              {uniqueCategories.map((category) => (
                <a
                  key={category}
                  onClick={() =>
                    handleEventClick(
                      events.find((event) => event.category_name === category)
                    )
                  }
                  className="cursor-pointer"
                >
                  <h3 className="mb-2">{category}</h3>
                </a>
              ))}
            </h6>
            <h6 className="mb-2 text-white text-sm">
              <a href="/gallery">Gallery</a>
            </h6>
            {/* <h6 className="mb-2 text-white text-sm"><a href="/">Achievements</a></h6> */}
            <h6 className="mb-2 text-white text-sm">
              <a href="/admissions">Admissions</a>
            </h6>
            <h6 className="mb-2 text-white text-sm">
              <a href="/MeetFaculty">Our Team</a>
            </h6>
          </div>
        </div>

        {/* Third Column: Contact Information */}
        <div className="lg:w-1/3 flex flex-col items-center">
          <h3 className="text-xl font-semibold mb-4 text-white">
            Contact Information
          </h3>
          <h6 className="flex gap-2 text-white mb-2 text-sm ml-[-16%]">
            <FaMapMarkerAlt size={27} /> Sri Jyothi Polytechnic ,
          </h6>
          <h6 className=" mb-2 text-sm ml-[28%] sm:ml-[28%] md:ml-[15%] lg:ml-[28%] xl:ml-[28%] 2xl:ml-[28%]">
            KALAVAPAMULA-521164, Vuyyuru Mandal, <br />
            Krishna Dist., Andhra Pradesh, India
          </h6>
          <p className="flex gap-2 text-white text-sm ml-[18%] sm:ml-[18%] md:ml-[9%] lg:ml-[18%] xl:ml-[18%] 2xl:ml-[18%]">
            <span className="mt-0 mb-3">
              <FaPhone size={22} className="" />
            </span>
            08676-283921, 9390019382, 6304732269
          </p>
          <p className="flex gap-2 text-white text-sm ml-[3%] sm:ml-[3%] md:ml-[0%] lg:ml-[3%] xl:ml-[3%] 2xl:ml-[3%]">
            <span className="mt-0">
              <FaEnvelope size={22} />
            </span>
            <a href="mailto:srijyothipolytechnic@gmail.com">
              srijyothipolytechnic@gmail.com
            </a>
          </p>
        </div>
      </div>
      <div className="text-center mt-6">
    <a href="https://oakyaitservices.com/">
    <h1 >
        Copyright © 2025 Designed by<strong className="hover:underline"> Oakya IT Services.</strong>  All Rights Reserved.
      </h1>
    </a>
    </div>
    </div>
  );
};

export default Footer;
